// 开讲新版

// const AboutLive = require('@/comm/AboutLive.page');
// const Tags = require('@/comm/Tags.page');
// const CouponsRule = require('../page/CouponsRule.page');
// const GlutesRule = require('../page/GlutesRule.page');
// const Cashier = require('../page/cashier/Cashier.page');
// const UpdateTip = require('../page/UpdateTip.page');
// const TreeCoin = require('../page/TreeCoin.page');
// const Questions = require('../page/Questions.page');
// const WxError = require('../page/WxError.page');
// const WriteMessage = require('../page/index/WriteMessage.page');
// const InviteRule = require('../page/InviteRule');

const AboutLive = () => import('@/comm/AboutLive.page');
const Tags = () => import('@/comm/Tags.page');
const CouponsRule = () => import('../page/CouponsRule.page');
const GlutesRule = () => import('../page/GlutesRule.page');
const Cashier = () => import('../page/cashier/Cashier.page');
const UpdateTip = () => import('../page/UpdateTip.page');
const TreeCoin = () => import('../page/TreeCoin.page');
const TreeBalance = () => import('../page/TreeBalance.page');
const Questions = () => import('../page/Questions.page');
const WxError = () => import('../page/WxError.page');
const WriteMessage = () => import('../page/index/WriteMessage.page');
const InviteRule = () => import('../page/InviteRule');
const EvaluationList = () => import('../page/evaluation/list/index.page');
const Channel = () => import('../page/channel/channel.page');
const Leaderboard = () => import('../page/leaderboard/index.page');
const WyethCourse = () => import('../page/wyethCourse/index.page');


export default [
  {
    path: '/aboutLive',
    name: 'aboutLive',
    meta: {
      pageTitle: '关于开讲',
      requiresAuth: false         // 是否需要登录
    },
    component: AboutLive
  },

  // 礼券页规则说明
  {
    path: '/couponsRule',
    name: 'couponsRule',
    meta: {
      pageTitle: '规则说明',
      requiresAuth: false         // 是否需要登录
    },
    component: CouponsRule
  },

  // 健身规则说明
  {
    path: '/glutesRule',
    name: 'glutesRule',
    meta: {
      pageTitle: '规则说明',
      requiresAuth: false         // 是否需要登录
    },
    component: GlutesRule
  },

  // 课程邀请规则
  {
    path: '/inviteRule',
    name: 'InviteRule',
    meta: {
      pageTitle: '课程邀请规则',
      requiresAuth: false         // 是否需要登录
    },
    component: InviteRule
  },

  // 微信收银台
  {
    path: '/info/:payType(weixin)',
    name: 'cashier',
    component: Cashier,
    meta: {
      pageTitle: '收银台',
      requiresAuth: false,         // 是否需要登录
      authType: 'user',
      isCourse: true             // 需要强跳转
    }
  },

  // 升级页
  {
    path: '/extra/updatetip',
    name: 'UpdateTip',
    meta: {
      pageTitle: '升级提醒',
      requiresAuth: false         // 是否需要登录
    },
    component: UpdateTip
  },

  {
    path: '/treeCoin',
    name: 'TreeCoin',
    component: TreeCoin,
    meta: {
      pageTitle: '树币',
      requiresAuth: true,
      authType: 'user'
    }
  },

  {
    path: '/treeBalance',
    name: 'TreeBalance',
    component: TreeBalance,
    meta: {
      pageTitle: '树币余额',
      requiresAuth: true,
      authType: 'user'
    }
  },

  {
    path: '/treeCoin/list',
    name: 'TreeCoinList',
    component: TreeCoin,
    meta: {
      pageTitle: '树币',
      requiresAuth: true,
      authType: 'user'
    }
  },

  // 问题说明
  {
    path: '/normalQuestions',
    name: 'questionsPage',
    component: Questions
  },

  // 标签页
  {
    path: '/tags/:tagId/:name',
    name: 'TagsPage',
    component: Tags,
    meta: {
      pageTitle: '标签页',
      requiresAuth: false
    }
  },

  {
    path: '/getWxError',
    name: 'errorPage',
    component: WxError
  },
  // 写留言
  {
    path: '/writeMessage/:liveId',
    name: 'WriteMessage',
    component: WriteMessage,
    meta: {
      pageTitle: '写留言',
      requiresAuth: true,
      authType: 'user'
    }
  },
  // 评价列表
  {
    path: '/evaluation/list',
    name: 'EvaluationList',
    component: EvaluationList,
    meta: {
      pageTitle: '课程评价',
      requiresAuth: false
    }
  },
  // 课程频道页
  {
    path: '/channel/:channelId',
    name: 'Channel',
    component: Channel,
    meta: {
      pageTitle: '频道页',
      requiresAuth: false
    }
  },
  // 排行榜 Leaderboard
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: Leaderboard,
    meta: {
      pageTitle: '宝妈都在学',
      requiresAuth: false
    }
  },
  // 惠氏课程聚合页 WyethCourse
  {
    path: '/wyethCourse',
    name: 'WyethCourse',
    component: WyethCourse,
    meta: {
      pageTitle: '精品课程',
      requiresAuth: false
    }
  }
];



// WEBPACK FOOTER //
// ./src/user/router/other.js